import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { DatatableDefaultOptions } from '@app/DatatableDefaultOptions';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { SnowAreaDataTableViewModel } from '@app/models/SnowAreaDataTableViewModel';
import { DataTablesRequest } from '@app/models/DataTablesRequest';
import { DataTablesResponse } from '@app/models/DataTablesResponse';

@Component({
    selector: 'app-snow-areas-datatable',
    templateUrl: './snow-areas-datatable.component.html',
    styleUrls: ['./snow-areas-datatable.component.css']
})
export class SnowAreasDatatableComponent implements OnInit {

    constructor(
        public ngxSmartModalService: NgxSmartModalService,
        private dataTableOptions: DatatableDefaultOptions,
        private http: HttpClient
    ) { }

    @ViewChild(DataTableDirective)
    private datatableElement: DataTableDirective;
    snowAreaDtOptions: DataTables.Settings = {};
    snowAreas: SnowAreaDataTableViewModel[]
    modalEdit: string = 'snowAreaEditModal'
    modalRemove: string = 'snowAreaRemoveModal'

    edit(snowArea: SnowAreaDataTableViewModel): void {
        this.ngxSmartModalService.resetModalData(this.modalEdit)

        this.http.get<SnowAreaDataTableViewModel>("/api/snowArea/update/" + snowArea.id)
            .subscribe(data => {
                this.ngxSmartModalService.setModalData(data, this.modalEdit);
                this.ngxSmartModalService.open(this.modalEdit);
            });
    }

    remove(snowArea: SnowAreaDataTableViewModel): void {
        this.ngxSmartModalService.setModalData(Number(snowArea.id), this.modalRemove);
        this.ngxSmartModalService.open(this.modalRemove);
    }

    ngOnInit() {
        this.initDatatable()
    }

    ngAfterViewInit() {
        this.reloadDatatableOnModalCloseSuccess(this.modalEdit)
        this.reloadDatatableOnModalCloseSuccess(this.modalRemove)
    }

    initDatatable(): void {
        let self = this
        let lastDraw = 0
        this.snowAreaDtOptions = {
            ...this.dataTableOptions.defaults, ...{
                ajax: (dataTablesParameters: DataTablesRequest, callback: (data: DataTablesResponse) => any) => {
                    let request = JSON.stringify(dataTablesParameters)
                    self.http.get<DataTablesResponse>(`api/snowArea/Datatable?request=${request}`).subscribe(response => {
                        if (response.draw < lastDraw) {
                            return;
                        }
                        lastDraw = response.draw
                        self.snowAreas = response.data;
                        let callbackResponse: DataTablesResponse = {
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: [],
                            draw: 0
                        }
                        callback(callbackResponse);
                    });
                },
            },
            columns: [
                { data: 'name' }
            ]
        }
    }

    reloadDatatableOnModalCloseSuccess(modalName: string) {
        this.ngxSmartModalService.getModal(modalName).onClose.subscribe((modal: NgxSmartModalComponent) => {
            let data = modal.getData()
            if (data && data.success === true) {
                this.reloadDatatable()
            }
        });
    }

    reloadDatatable(): void {
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => dtInstance.ajax.reload());
    }

}
